/** Strips leading and trailing slashes without a regex, whose backtracking is quadratic on a long run of slashes. */
export const trimSlashes = (path: string): string => {
	let start = 0
	let end = path.length
	while (start < end && path[start] === '/') start++
	while (end > start && path[end - 1] === '/') end--
	return path.slice(start, end)
}

/** Strips trailing slashes only, keeping a leading one. */
export const trimTrailingSlashes = (path: string): string => {
	let end = path.length
	while (end > 0 && path[end - 1] === '/') end--
	return path.slice(0, end)
}
